import { CarVoucher } from '@esportal/portal-service';
import { Vehicle, VehicleStatus } from '@esportal/portal-service';
import { isVehicle } from '../helpers/common-helpers';

export const formatOwnership = (vehicles: Vehicle[] | CarVoucher[] | undefined | null) => {
	const formatedVehicles: any = [];

	if (vehicles) {
		vehicles.forEach((vehicle) => {
			if (
				isVehicle(vehicle) &&
				(vehicle.status == VehicleStatus.READY ||
					vehicle.status == VehicleStatus.TO_BE_CONFIRMED ||
					vehicle.status == VehicleStatus.TO_BE_DELETED)
			) {
				let date,
					year,
					month,
					day,
					finalDate = undefined;

				if (vehicle.vgedRegistrationDate) {
					date = new Date(vehicle.vgedRegistrationDate);
					year = date.getFullYear();
					month = date.getMonth() + 1;
					day = date.getDate();
				}
				if (date) {
					finalDate = `${year}-${month}-${day}`;
				}

				const formatedVehicle = {
					manufacturer: 'Volkswagen', // Fijo
					carlineName: vehicle.vgedModelGroup, // comercialDenomination
					model: vehicle.vgedModel, // comercialDenominationSli
					modelYear: vehicle.modelYear, // modelYear
					derivative: vehicle.vgedModel, // comercialDenominationSli
					registrationDate: finalDate, // licenseDate en formato correcto
					bodyType: undefined, // undefined
					fuelType: undefined, // undefined
					transmission: undefined, // undefined
					engineSize: undefined, // undefined
					engineSizeUnit: undefined, // undefined
					mileage: undefined, // undefined
					mileageUnit: undefined, // undefined
					currency: undefined, // undefined
					estimatedValueExcellent: undefined, // undefined
					estimatedValueGood: undefined, // undefined
					estimatedValueAverage: undefined, // undefined
					additionalAttributes: [],
					leaseCompany: undefined, // undefined
					vehicleVerification: undefined, // undefined
					vehicleId: vehicle.name, // vin
				};

				formatedVehicles.push(formatedVehicle);
			}
		});
		return formatedVehicles;
	}
	return [];
};

export const pageInPath = (newPath: string) => {
	const portalPath = window.location.pathname;

	if (portalPath.includes(newPath)) return;

	const portalPathIndex = portalPath.indexOf('.html');

	if (portalPathIndex !== -1 && window.history?.replaceState) {
		const indexApp = portalPath.indexOf('/_app', portalPathIndex + 5);
		let updatedPath: string;

		if (indexApp !== -1) {
			const basePath = portalPath.substring(0, indexApp);
			updatedPath = basePath + '/_app/' + newPath;
		} else {
			updatedPath = portalPath + '/_app/' + newPath;
		}

		window.history.replaceState(null, '', `${updatedPath}`);
	}
};
